import React from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

interface Props {
  title: string;
  description: string;
}

const Header: React.FC<Props> = ({ title, description }) => (
  <Box>
    <Inscription weight={700} size="3xl">
      {title}
    </Inscription>
    <Inscription size="large" margin={{ top: 'spacing8' }}>
      {description}
    </Inscription>
  </Box>
);

export default Header;
